module.exports = __webpack_public_path__ + "static/footer-cfbbfeaecb239407fbc00c6e2ccff4b3.png";